'use client';

import { useRef, type ReactNode } from 'react';
import { useDisclosureMotion } from './useDisclosureMotion';
import { Eyebrow } from './Eyebrow';
import styles from './interior.module.css';

/** Route-owned headings and links stay in initial HTML; only descriptions collapse. */
export function RelatedResources({
  children,
  label = 'Related reading',
}: {
  children: ReactNode;
  label?: string;
}): React.ReactElement {
  const root = useRef<HTMLElement>(null);
  useDisclosureMotion(root, { panelSelector: '[data-resource-description]' });
  return (
    <section ref={root} className={styles.relatedResources} aria-label={label}>
      <Eyebrow>{label}</Eyebrow>
      {children}
    </section>
  );
}

export function ResourceDescription({
  id,
  children,
  label = 'Read summary',
}: {
  id: string;
  children: ReactNode;
  label?: string;
}): React.ReactElement {
  return (
    <details id={id} className={styles.resourceDescription}>
      <summary>{label}</summary>
      <div data-resource-description>{children}</div>
    </details>
  );
}
